import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ADMIN_CODE = 'Z1234';  // Verander dit naar jouw gewenste code

function AdminLogin() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.trim() === ADMIN_CODE) {
      localStorage.setItem('isAdmin', 'true');
      navigate('/admin/dashboard');
    } else {
      setError('Verkeerde code');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-center mb-8">Admin Inloggen</h1>

        <form onSubmit={handleSubmit}>
          <label className="block text-lg mb-2">Admin code</label>
          <input
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Voer de admin code in"
            className="w-full px-4 py-3 text-xl border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none mb-4"
            autoFocus
          />

          {error && <p className="text-red-600 text-center mb-4">{error}</p>}

          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-lg text-xl"
          >
            Inloggen
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;